import { render, staticRenderFns } from "./AppConfigWarningMsgBox.vue?vue&type=template&id=2af8da1b&"
import script from "./AppConfigWarningMsgBox.vue?vue&type=script&lang=js&"
export * from "./AppConfigWarningMsgBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardActions,VDialog})


/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af8da1b')) {
      api.createRecord('2af8da1b', component.options)
    } else {
      api.reload('2af8da1b', component.options)
    }
    module.hot.accept("./AppConfigWarningMsgBox.vue?vue&type=template&id=2af8da1b&", function () {
      api.rerender('2af8da1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/modal/AppConfigWarningMsgBox.vue"
export default component.exports